import humps from 'humps';

/* Utlity funciton to handle UUIDs */
export function decodeBase64UUID(str){
  if (str === null) return '';
  let urlUnsafe = str.replace(/-/g, '+').replace(/_/g, '/');
  let arr = atob(urlUnsafe).split('').map(c => {
    let char = c.charCodeAt(0);
    return ('0'+char.toString(16)).substr(-2,2);
  });
  arr.splice(4, 0, '-');
  arr.splice(7, 0, '-');
  arr.splice(10, 0, '-');
  arr.splice(13, 0, '-');
  return arr.join('').toLowerCase();
}

class OrderConverter {

  constructor() {

  }

  /**
    Converts order from OAPI internal V2 model to something a sane
    FE dev would be proud to use. Camelcase, real UUIDs instead of oddly
    encoded base64 versions, and other convenience transforms.
    @param {ConfirmTemplateModel}
    @returns {ConvertedOrderModel}
    @public
  **/
  convert(confirmTemplateModel) {
    //4e906740-8453-430c-a2c8-e211d4ae88f3
    let convertedModel = humps.camelizeKeys(confirmTemplateModel);
    convertedModel.order.uuid = decodeBase64UUID(convertedModel.order.uuid);
    convertedModel.order.merchantUuid = decodeBase64UUID(convertedModel.order.merchantUuid);
    if (convertedModel.view) {
        convertedModel.view.countDinerLineItems = new Map(Object.entries(confirmTemplateModel.view.count_diner_line_items));
        if (convertedModel.view.countDinerSpecialInstruction) {
          convertedModel.view.countDinerSpecialInstruction = new Map(Object.entries(confirmTemplateModel.view.count_diner_special_instruction));
        }
    }
    return convertedModel;
  }

}

export default new OrderConverter();



// WEBPACK FOOTER //
// ./client/app/util/order_converter.js